import { RateCodeSearchState } from '~/components/Cruises/components/shared/RateCodeGridConfig';

export const rateCodeQueryKeys = {
  all: ['rate-codes'] as const,
  lists: () => [...rateCodeQueryKeys.all, 'list'] as const,
  list: (vendorCode: string | undefined, search: RateCodeSearchState, page: number) =>
    [...rateCodeQueryKeys.lists(), vendorCode, search, page] as const,
  byCodes: (rateCodes: ReadonlyArray<string>) => [...rateCodeQueryKeys.lists(), 'codes', rateCodes] as const,
  recentlyCreated: (createdAtStart: string | null, createdAtEnd: string | null) =>
    [...rateCodeQueryKeys.lists(), 'recently-created', createdAtStart, createdAtEnd] as const,
};
